var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("template", {
    slot: "header"
  }, [_c("el-breadcrumb", {
    attrs: {
      separator: "/"
    }
  }, [_c("el-breadcrumb-item", {
    attrs: {
      to: {
        path: "/article/story"
      }
    }
  }, [_vm._v("公司信息")]), _c("el-breadcrumb-item", [_vm._v("编辑信息")])], 1)], 1), _c("el-form", {
    staticClass: "wlc-form-page",
    attrs: {
      model: _vm.form,
      "label-position": "left",
      "label-width": "60px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "语言"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.lang,
      callback: function callback($$v) {
        _vm.lang = $$v;
      },
      expression: "lang"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "zh"
    }
  }, [_vm._v("中文")]), _c("el-radio-button", {
    attrs: {
      label: "en"
    }
  }, [_vm._v("英文")]), _c("el-radio-button", {
    attrs: {
      label: "tw"
    }
  }, [_vm._v("繁体")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "标题"
    }
  }, [_vm.lang == "zh" ? _c("el-input", {
    model: {
      value: _vm.form.title.ch,
      callback: function callback($$v) {
        _vm.$set(_vm.form.title, "ch", $$v);
      },
      expression: "form.title.ch"
    }
  }) : _vm._e(), _vm.lang == "en" ? _c("el-input", {
    model: {
      value: _vm.form.title.en,
      callback: function callback($$v) {
        _vm.$set(_vm.form.title, "en", $$v);
      },
      expression: "form.title.en"
    }
  }) : _vm._e(), _vm.lang == "tw" ? _c("el-input", {
    model: {
      value: _vm.form.title.tw,
      callback: function callback($$v) {
        _vm.$set(_vm.form.title, "tw", $$v);
      },
      expression: "form.title.tw"
    }
  }) : _vm._e()], 1), _c("el-form-item", {
    attrs: {
      label: "内容"
    }
  }, [!_vm.loading ? _c("div", {
    staticClass: "editor-container"
  }, [_c("wlc-rich-text", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.lang === "zh",
      expression: "lang === 'zh'"
    }],
    attrs: {
      content: _vm.form.content.ch,
      id: "zh_".concat(_vm.$route.query.id)
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form.content, "ch", $event);
      }
    }
  }), _c("wlc-rich-text", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.lang === "en",
      expression: "lang === 'en'"
    }],
    attrs: {
      content: _vm.form.content.en,
      id: "en_".concat(_vm.$route.query.id)
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form.content, "en", $event);
      }
    }
  }), _c("wlc-rich-text", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.lang === "tw",
      expression: "lang === 'tw'"
    }],
    attrs: {
      content: _vm.form.content.tw,
      id: "tw_".concat(_vm.$route.query.id)
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form.content, "tw", $event);
      }
    }
  })], 1) : _vm._e()]), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("提交")])], 1)], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };